import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetSAssignmentQuery, usePostAssignmentsMutation, useUpdateSAssignmentMutation } from '../../features/assignment/assignmentApi';
import { useGetAllVideosQuery } from '../../features/video/videoApi';

const AddAssignment = () => {

  
    // "title": "Assignment 1 - Implement Debounce Function",
    // "video_id": 1,
    // "video_title": "Debounce Function in JavaScript - JavaScript Job Interview question",
    // "totalMark": 100


    const {id: videoId } = useParams()
    const [videoData, setVideoData] = useState({});
    const {data:allVideo}=useGetAllVideosQuery()

    const { data: getAssignment, isLoading: getLoading, isError: getIsError, error: getError } = useGetSAssignmentQuery(videoId, { skip: !videoId });
    const navigate = useNavigate();


    useEffect(() => {
        setVideoData({ ...getAssignment })
    }, [getAssignment])

    const handleChangeInput = (event) => {
        const { name, value } = event.target;
        setVideoData(prev => ({ ...prev, [name]: value }))
    }
    const [postAssignmentsFunc, { isLoading, data, isSuccess, isError, error }] = usePostAssignmentsMutation();
    const [updateAssignmentFunc, { isLoading: updateLoading, data: updateData, isSuccess: updateIsSuccess, isError: updateIsError, error: updateError }] = useUpdateSAssignmentMutation();
    const handleSubmit = (e) => {
        e.preventDefault();

        if (videoId) {
            updateAssignmentFunc({ id: videoId, data: videoData })

        } else {

            postAssignmentsFunc({...videoData,video_title:allVideo?.find(v=>v.id==videoData?.video_id)?.title})
        }
    }
    useEffect(() => {
        if (isSuccess || updateIsSuccess) {
            navigate('/admin/assignment')
        }
    }, [updateIsSuccess, isSuccess])


    return (
        <>

            <section className="py-6 bg-primary h-screen grid place-items-center">
                <div className="mx-auto max-w-md px-5 lg:px-0 " style={{ width: '600px' }}>
                    <div>

                        <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
                            Add Assignment
                        </h2>
                    </div>
                    <form className="mt-8 space-y-6" action="#" method="POST" onSubmit={handleSubmit}>
                        <input type="hidden" name="remember" defaultValue="true" />
                        <div className="rounded-md shadow-sm -space-y-px">
                            <div>
                                <label htmlFor="name" className="sr-only">Title</label>
                                <input onChange={handleChangeInput} id="name" value={videoData?.title} name="title" type="name" autoComplete="name" required className="login-input rounded-t-md" placeholder="Title" />
                            </div>

                            <div>
                                <label htmlFor="name" className="sr-only">Video Title</label>
<select value={videoData?.video_id} onChange={handleChangeInput} name="video_id" className="login-input rounded-t-md">
    <option value="">Choose</option>
   
  {allVideo?.map(video=>( <option key={video?.id} value={video?.id}>{video?.title}</option>))}
</select>

                           
                            </div>

                            <div>
                                <label htmlFor="name" className="sr-only">Total Mark</label>
                                <input value={videoData?.totalMark} max={100} onChange={handleChangeInput} id="name" name="totalMark"  type="number" autoComplete="name" required className="login-input rounded-t-md" placeholder="Total Mark" />
                                {/* <textarea/> */}
                            </div>

                        </div>
                        <div>
                            <button disabled={isLoading||updateLoading} type="submit" className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500">
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </section>

        </>
    )
}

export default AddAssignment